import { messageTemplateBaseModel } from './crud';

export * from './types';

export const useMessageTemplatesById = messageTemplateBaseModel.fetchById();
export const useMessageTemplatesByIds = messageTemplateBaseModel.fetchByIds();
export const useMessageTemplatesMany = messageTemplateBaseModel.fetchMany();
export const useMessageTemplatesCount = messageTemplateBaseModel.count();
export const useMessageTemplatesManyInfiniteQuery =
  messageTemplateBaseModel.fetchPaginated();
export const useMessageTemplatesUpdateOne = messageTemplateBaseModel.edit();
export const useMessageTemplatesCreateOne = messageTemplateBaseModel.create();
export const useMessageTemplatesRemoveOne = messageTemplateBaseModel.delete();
export const useMessageTemplatesRemoveByIds =
  messageTemplateBaseModel.deleteByIds();

export const useMessageTemplatesByIdV2 = messageTemplateBaseModel.fetchByIdV2();
export const useMessageTemplatesByIdsV2 =
  messageTemplateBaseModel.fetchByIdsV2();
export const useMessageTemplatesManyV2 = messageTemplateBaseModel.fetchManyV2();
export const useMessageTemplatesCountV2 = messageTemplateBaseModel.countV2();
export const useMessageTemplatesManyInfiniteQueryV2 =
  messageTemplateBaseModel.fetchPaginatedV2();
export const useMessageTemplatesUpdateOneV2 = messageTemplateBaseModel.editV2();
export const useMessageTemplatesCreateOneV2 =
  messageTemplateBaseModel.createV2();
export const useMessageTemplatesRemoveOneV2 =
  messageTemplateBaseModel.deleteV2();
export const useMessageTemplatesRemoveByIdsV2 =
  messageTemplateBaseModel.deleteByIdsV2();

export const useMessageTemplatesPagination =
  messageTemplateBaseModel.fetchPaginated();
export const useMessageTemplatesPaginationV2 =
  messageTemplateBaseModel.fetchPaginatedV2();
